<template>
    <div class="page cardsManageSection">
        <TopNavBar class="mb-4"/>
        <div class="wrapBox">
            <div class="container">
                <div class="kettlCardsBox">
                    <div class="h1 descktopMediaBox">
                        Payment Methods
                    </div>
                    <div class="h2 mb-4">
                        Saved Kettleman’s Cards
                    </div>
                    <div class="text-center">
                        <router-link :to="{name: 'MemberBarCode'}" class="smlBtn my-4">
                            Scan Loyalty card
                        </router-link>
                    </div>
                    <GiftCardsList/>
                    <router-link :to="{name: 'My-wallet'}" class="addcard">
                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M11 5.55646H9V9.65242H5V11.7004H9V15.7963H11V11.7004H15V9.65242H11V5.55646ZM10 0.436523C4.48 0.436523 0 5.02399 0 10.6764C0 16.3288 4.48 20.9163 10 20.9163C15.52 20.9163 20 16.3288 20 10.6764C20 5.02399 15.52 0.436523 10 0.436523ZM10 18.8683C5.59 18.8683 2 15.1922 2 10.6764C2 6.16062 5.59 2.4845 10 2.4845C14.41 2.4845 18 6.16062 18 10.6764C18 15.1922 14.41 18.8683 10 18.8683Z"
                                fill="#CF3339"/>
                        </svg>
                        <span class="h4">Load Wallet</span>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GiftCardsList from "../../components/checkout/GiftCardsList";
    import TopNavBar from "../../components/shared/TopNavBar";
    export default {
        name: "ManageCards",
        components: {TopNavBar, GiftCardsList},
        created() {
            this.$store.commit("shared/setTopBar", {title: "Manage Cards", showBackButton: true});
        },
    }
</script>
